import React from "react";
import PlaceholderAtm from "../../atoms/PlaceholderAtm";
import RichTextMol from "../RichTextMol";
export var renewalPaymentTypography = "tiny1";
function RenewalPayment(_ref) {
  var isLoading = _ref.isLoading,
    heightSpace = _ref.heightSpace,
    renewalPayment = _ref.renewalPayment;
  return /*#__PURE__*/React.createElement(React.Fragment, null, isLoading ? /*#__PURE__*/React.createElement(PlaceholderAtm, {
    widthSpace: 19,
    heightSpace: heightSpace
  }) : /*#__PURE__*/React.createElement(RichTextMol, {
    typography: renewalPaymentTypography,
    emphasis: "medium",
    data: renewalPayment !== null && renewalPayment !== void 0 ? renewalPayment : "\xA0",
    lineBreakHeightSpace: 1
  }));
}
export default RenewalPayment;